<template v-if="levelComponent">
  <div class="header">{{ $t(levelComponent.options.header) }}</div>
  <img
    class="image"
    :src="currentAdvisorPath">
  <div class="question">{{ $t(levelComponent.options.question) }}</div>
  <div class="answers">
    <button :class="{
        'mt-2': index > 0,
        'answer': true,
        'answer--outline': index === 1,
        'answer--default': index === 0,
      }"
      @click.prevent="performAction(answer)"
      v-for="(answer, index) in levelComponent.options.answers">
      {{ $t(answer.text) }}
    </button>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters({
        advisorIcon: 'advisorIcon',
        advisorIcons: 'advisorIcons',
      }),
      currentAdvisorPath() {
        let currentAdvisor = this.advisorIcon
        if (currentAdvisor) {
          let ca = this.advisorIcons.find(advisor => advisor.id === currentAdvisor)
          if (ca) {
            return ca.preview
          }
        }
      }
    },
    emits: [
      'setWindowMode',
      'quit'
    ]
  }
</script>

<style lang="scss" scoped>
  .answers {
    @apply
      pb-4
      px-4
      bg-white;

    .answer {
      @apply
        p-3.5
        w-full
        text-sm
        rounded
        shadow-ctm
        text-center
        cursor-pointer;

      &.answer--outline {
        @apply
          bg-white
          text-ctm-primary;
      }

      &.answer--default {
        @apply
          text-white
          bg-ctm-primary
          border-transparent;
      }
    }
  }

  .image {
    @apply
      block
      w-full
      max-h-36
      object-cover;
  }

  .question {
    @apply
      py-5
      px-10
      text-xl
      bg-white
      text-center
      text-ctm-primary;
  }

  .header {
    @apply
      p-3.5
      text-xl
      uppercase
      text-white
      text-center
      rounded-t
      bg-ctm-primary;
  }
</style>